import React from 'react';
import Link from 'next/link';

export interface BreadcrumbPreviousPage {
  link: string;
  label: string;
}

export interface BreadcrumbsProps extends React.HTMLProps<HTMLDivElement> {
  currentPage: string;
  previousPages?: BreadcrumbPreviousPage[];
  activeColor?: string;
}

export default function Breadcrumbs({currentPage, previousPages, activeColor, ...others}: BreadcrumbsProps) {
  const isHomeOnly = !currentPage
  if (!activeColor) {
    activeColor = 'inherit'
  }
  return <>
     <style jsx>{`
      .breadcrumb {
        background-color: transparent;
        font-size: 0.8rem;
      }

      .breadcrumb-item + .breadcrumb-item::before {
        color: ${activeColor};
        content: '>';
      }

      .breadcrumb-item.active {
        color: ${activeColor};
      }
    `}</style>
    <nav aria-label="breadcrumb" {...others}>
      <ol className="breadcrumb p-2">
        {isHomeOnly ? (
          <li className="breadcrumb-item active" aria-current="step">Home</li>
        ) : (
          <li className="breadcrumb-item" aria-current="step">
            <Link href="/">Home</Link>
          </li>
        )}
        {!isHomeOnly && (
          <>
            {Array.isArray(previousPages) && previousPages.map((page, index) => (
              <li key={index} className="breadcrumb-item" aria-current="step">
                <Link href={page.link}>{page.label}</Link>
              </li>
            ))}
            <li className="breadcrumb-item active" aria-current="location">{currentPage}</li>
          </>
        )}
      </ol>
    </nav>
  </>;
}